module.exports = __webpack_public_path__ + "img/main-carats.29b20a07.svg";